import { Link, Text } from 'platform-components';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import ym from 'react-yandex-metrika';

import './class__parent-notification.scss';

interface ParentNotificationProps {
    intl: IntlShape;
}

export const ParentNotification = ({ intl }: ParentNotificationProps) => {
    const tellParentLinkUrl = intl.formatMessage({ id: 'tellParent.link.url' });

    return (
        <div className="class__parent-notification">
            <Text id="class.parentNotification.header" weight={Text.WEIGHT.M} />
            <div className="class__parent-notification-description">
                <Text id="class.parentNotification.description" />
            </div>
            <Link
                onClick={() => ym('reachGoal', 'click_link', { from: window.location.href, url: tellParentLinkUrl })}
                target="_blank"
                theme={Link.THEME.PRIMARY}
                to={tellParentLinkUrl}
            >
                <Text id="class.parentNotification.link" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
            </Link>
        </div>
    );
};

export default injectIntl(ParentNotification);
